import useGetScriptExecutionDevices from '../../../../queries/scriptExecutionDetails/useGetScriptExecutionSectionDevices';
import WdacScriptExecutionTable from '../../../wdac-results/tabs/WdacScriptExecution/WdacScriptExecutionTable';

const ScriptExecutionSection = () => {
  const {
    isLoading,
    data: scriptExecutionList,
    lastElementRef,
    isFetching,
    totalCount,
    query,
  } = useGetScriptExecutionDevices();

  return (
    <WdacScriptExecutionTable
      isLoading={isLoading}
      isFetching={isFetching}
      scriptExecutionList={scriptExecutionList}
      lastElementRef={lastElementRef}
      totalCount={totalCount}
      query={query}
      type="device"
    />
  );
};

export default ScriptExecutionSection;
